import styled from "styled-components";

export const CartWrapper = styled.section`
  margin: 2rem auto;
  min-height: calc(100vh - 224px);
`;
